// extracted by mini-css-extract-plugin
export var listContainer = "bv_dt";
export var listItem = "bv_ds";
export var listWrapper = "bv_fc";